import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  toggleSection: classNames(
    'sm:flex',
    'justify-between',
    'content-center',
    '!mt-7',
  ),
  toggleButton1: classNames(
    '!mr-2',
    'capitalize',
  ),
  toggleButton2: classNames(
    'capitalize',
  ),
  toggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
  download: classNames(
    'w-full',
    'block',
    '!-mt-8',
    '!mb-8',
    'md:!my-8',
    'rounded-3xl',
    '!px-6',
    '!py-1.5',
    'bg-secondaryBlue',
    'text-white',
    'shadow-md',
    'border-secondaryBlue',
    'hover:bg-secondaryBlue-600',
    'hover:text-white',
    'font-bold',
    'border',
    'text-lg',
    'text-center',
    'md:!mr-6',
    'md:!w-auto',
  ),
};

export default styles;
